import axios from "axios";
import {appendHttpUrlToApi} from "../../../utility/Utility";
import Constants from "../../../constants/Constants";

export function xhrSaveUserInfo (data, onSuccess, onFailure) {

    data.append("action_type", "action_save_support_request");
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'post',
        url: appendHttpUrlToApi("/"),
        data: data
    }).then( res => {
        onSuccess(res);
    }).catch((error)=>{
        onFailure();
    });
}


// WEBPACK FOOTER //
// ./src/components/GetInTouch/Services/Services.js